var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./visibilitat-modal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3a7785fc\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./visibilitat-modal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/perfil/components/visibilitat-modal/visibilitat-modal.vue
// module id = 277
// module chunks = 0